import api from '@/services/api'

const state = {
  current: {},
}

const getters = {}

// actions
const actions = {
  emptyCache({ commit }) {
    return new Promise(resolve => {
      api()
        .get("/cache/customer/clean")
        .then(response => {
          resolve(response.data);
        });
    });
  },
  precalculate({ commit }, data) {
    return new Promise((resolve, reject) => {
      api()
        .post("/data/precalculate", data)
        .then(response => {
          resolve(response.data);
        });
    });
  },
  switchSiteAndDataModel({ commit }, data) {
    return new Promise((resolve, reject) => {
      api()
        .post(`/customer/site/${data.siteId}/channel/${data.channelId}/switch-site-datamodel`, data.data)
        .then(response => {
          resolve(response.data);
        });
    });
  },
  storeChannel({ commit }, data) {
    return new Promise((resolve, reject) => {
      api()
        .post(`/customer/site/${data.site_guid}/channel`, data.channel)
        .then(response => {
          resolve(response.data);
        });
    });
  },
  editParameter({ commit }, data) {
    return new Promise((resolve, reject) => {
      api()
        .patch(`/customer/site/${data.site_guid}/parameter`, data.parameter)
        .then(response => {
          resolve(response.data);
        });
    });
  },
  addParameter({ commit }, data) {
    return new Promise((resolve, reject) => {
      api()
        .put(`/customer/site/${data.site_guid}/parameter`, data.parameter)
        .then(response => {
          resolve(response.data);
        });
    });
  },
  deleteParameter({ commit }, id) {
    return new Promise((resolve, reject) => {
      api()
        .delete(`/customer/parameter/${id}`)
        .then(response => {
          resolve(response.data);
        });
    });
  },
  listParameters({ commit }, site_guid) {
    return new Promise((resolve, reject) => {
      api()
        .get(`/customer/site/${site_guid}/parameters`)
        .then(response => {
          resolve(Array.isArray(response.data.data) ? response.data.data : []);
        });
    });
  },
  deleteChannel({ commit }, id) {
    return new Promise((resolve, reject) => {
      api().delete(`/customer/channel/${id}`).then((response) => {
        resolve(response.data)
      })
    })
  },
  bulkOperations({ commit }, data) {
    return new Promise(resolve => {
      api()
        .post("/customer/site/bulk", data)
        .then(response => {
          resolve(response.data);
        });
    });
  },
  measureTypesList({ commit }) {
    return new Promise(resolve => {
      api()
        .post("/customer/site/list/measureTypes")
        .then(response => {
          resolve(response.data.data);
        });
    });
  },
  dataModels({ commit }, guid) {
    return new Promise((resolve, reject) => {
      api()
        .get(`customer/${guid}/datamodels`)
        .then(response => {
          resolve(response.data.data);
        });
    });
  },
  edit({ commit }, data) {
    return new Promise((resolve, reject) => {
      api()
        .post("/customer/site", data.data)
        .then(response => {
          commit("current", response.data.data);
          resolve(response.data.data);
        });
    });
  },
  get({ commit }, id) {
    return new Promise(resolve => {
      api()
        .post("/customer/site/" + id)
        .then(response => {
          commit("current", response.data.data);
          resolve(response.data.data);
        });
    });
  },
  list({ commit }) {
    return new Promise(resolve => {
      api()
        .post("/user/sites")
        .then(response => {
          resolve(response.data.data);
        });
    });
  },
  channels({ commit }, customerGuid) {
    return new Promise(resolve => {
      api()
        .post("/customer/channels")
        .then(response => {
          resolve(response.data.data);
        });
    });
  },
  delete({ commit }, id) {
    return new Promise(resolve => {
      api()
        .post("/customer/site/" + id + "/delete")
        .then(response => {
          resolve();
        });
    });
  },
  tags({ commit }, guid) {
    return new Promise(resolve => {
      api()
        .post("/customer/" + guid + "/tags")
        .then(response => {
          resolve(response.data.data);
        });
    });
  },
  userTags({ commit }, guid) {
    return new Promise(resolve => {
      api()
        .post("/customer/tags")
        .then(response => {
          resolve(response.data.data);
        });
    });
  },
  applyFormulas({ commit }, guid) {
    return new Promise(resolve => {
      api()
        .post("/customer/site/" + guid + "/apply-formulas")
        .then(response => {
          resolve(response.data.data);
        });
    });
  },
  emptyFormulas({ commit }, guid) {
    return new Promise(resolve => {
      api()
        .post("/customer/site/" + guid + "/empty-formulas")
        .then(response => {
          resolve(response.data.data);
        });
    });
  },
  report({ commit }, params) {
    return new Promise(resolve => {
      api()
        .post("/report/" + params.guid + "/" + params.month)
        .then(response => {
          resolve(response.data.data);
        });
    });
  }
};

// mutations
const mutations = {
  current(state, current) {
    state.current = current
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sites.js